import { createApi } from '@reduxjs/toolkit/query/react';

import { apiRoreSessions } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import { RoreSession } from '~rore/types';

export const sessionsApi = createApi({
  reducerPath: 'roreSessionsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiRoreSessions }),
  tagTypes: ['sessions'],
  endpoints: (builder) => ({
    getRoreSession: builder.query<RoreSession, string>({
      query: (id) => ({ url: `/${id}`, method: 'GET' }),
      transformResponse: (payload) => unwrap<RoreSession>(payload),
      providesTags: (_result, _error, id) => [{ type: 'sessions', id }],
    }),
  }),
});

export const { useGetRoreSessionQuery } = sessionsApi;
